import { Modal } from './Modal';

export function HelpModal({ onClose }) {
  return (
    <Modal onClose={onClose}>
      <h2 className="modal-title">❓ Help Center</h2>

      <section className="help-section">
        <h3>How It Works</h3>
        <ol>
          <li>Enter the <strong>Asset Tag Number</strong> and press Tab or click away</li>
          <li>If the asset exists in the SharePoint register, details will auto-populate</li>
          <li>If it is not in the register, the portal queries Asset Tiger and fills tag, brand/model, serial, equipment type, and condition when found</li>
          <li>For assets found in neither system, fill in all required fields</li>
          <li>Choose <strong>Check Out</strong> to assign to a user, or <strong>Check In</strong> to return to office</li>
          <li>Review and confirm your submission</li>
        </ol>
      </section>

      <section className="help-section">
        <h3>Asset Register</h3>
        <p>
          Open the <strong>Asset Register</strong> tab to browse the same SharePoint
          list: tag, equipment type, assignee, project, status, condition, dates,
          and serial. Search or filter, export the current view as CSV, or click a
          row to check that asset in or out.
        </p>
      </section>

      <section className="help-section">
        <h3>Field Guide</h3>
        <ul>
          <li><strong>Asset Tag Number:</strong> Unique identifier for the asset</li>
          <li><strong>Brand and Model:</strong> e.g., "Dell Latitude 5520"</li>
          <li><strong>Serial Number:</strong> Manufacturer serial number for the asset</li>
          <li><strong>Project Number:</strong> Associated project identifier</li>
          <li><strong>Equipment Type:</strong> Laptop, Phone, Tablet, or Other</li>
          <li><strong>Condition:</strong> Current physical condition</li>
          <li><strong>Country:</strong> Country where the asset is located or being assigned</li>
          <li><strong>Assignee Email:</strong> User assigned to the asset (loaded from lookup; required on check-out)</li>
          <li><strong>Status:</strong> Active (checked out) or Returned (checked in)</li>
        </ul>
      </section>

      <section className="help-section">
        <h3>Backend Integration</h3>
        <p>
          This portal connects to SharePoint via Power Automate. The Asset Register
          tab loads the full list. When you enter an Asset Tag Number, it queries
          that same list first. If the tag is missing there, it looks the asset up
          in Asset Tiger and prefills the form so you can review it. Submitting
          still creates or updates the SharePoint register—no duplicates are created.
        </p>
      </section>

      <button type="button" className="btn btn-secondary" onClick={onClose}>
        Close
      </button>
    </Modal>
  );
}
